module.exports = __webpack_public_path__ + "static/media/VIP_Ticket@3x.366df448.png";